import { useState } from "react";
import { DecimoTerceiroInputCard } from "./components/DecimoTerceiroInputCard";
import { DecimoTerceiroResponse } from "./components/DecimoTerceiroResponse";
import { DecimoResponse } from "./decimo-terceiro";


export default function DecimoTerceiro() {
    const [results, setResults] = useState<DecimoResponse | null>(null);

    return (
        <>
            <DecimoTerceiroInputCard setResults={setResults} />
            {results && <DecimoTerceiroResponse results={results} />}
        </>
    );
}
